module.exports = "<div class=\"time-wrp js-time-region\"></div>\r\n<div class=\"svg-icons-wrp\">\r\n    <div class=\"svg-icons-wrp__empty\">\r\n        <svg class=\"svg-icons svg-icons_time\"><use xlink:href=\"#icon-time\" /></svg>\r\n    </div>\r\n    <div class=\"js-clear-button svg-icons-wrp__remove\">\r\n        <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=\"#icon-remove\" /></svg>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/timeEditor.hbs
// module id = 696
// module chunks = 0